export enum OrderSourceEnum {
  MANUAL = 'Manual',
  MOBILE_APP = 'App',
}